import _objectSpread from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/objectSpread2";
import State from '../ms-base/state';
export default _objectSpread({}, new State('tyre-families'));